<template>
	<div class="phone-container">
		<div class="fix phone-line">
			<van-cell-group class="phone-area-cell">
				<van-field class="phone-area" v-model="phone" placeholder="请输入手机号" @input="hasPhone" />
			</van-cell-group>
			<van-image class="resetphone" :class="{'hasPhone': isPhone==true}" @click="clearPhone" fit="cover" src="../../../static/images/sahnchu.png"/>
		</div>
		<div class="fix phone-line">
			<div class="fl imgCode-left">
				<van-cell-group>
					<van-field class="imgCode-area" v-model="imgCode" placeholder="请输入验证码(区分大小写)" @input="hasCode" />
				</van-cell-group>
			</div>
			<div class="fl code-line"></div>
			<div class="fr imgCode-right" @click="refreshCode">
				<s-identify :identifyCode="identifyCode"></s-identify>
			</div>
		</div>
		<div class="fix phone-line">
			<div class="fl msgCode-left">
				<van-cell-group>
					<van-field class="msgCode-area" v-model="msgCode" placeholder="请输入验证码" @input="hasMsgCode" />
				</van-cell-group>
			</div>
			<div class="fl code-line"></div>
			<div class="fl msgCode-right" :class="{'hasCode': isCode == true, 'chongfa': isCF == true}" @click="countDown">{{content}}</div>
		</div>
		<!-- <van-button round  size="large" class="sure" :class="{'sureBtn': isMsgCode == true}" @click="bindPhone">确定</van-button> -->
		<div class="sure" :class="{'sureBtn': isMsgCode == true}" @click="bindPhone">确定</div>
	</div>
</template>

<script>
	import SIdentify from "../../components/indetify.vue"
	export default {
		name: "codetest",
		components:{
			SIdentify
		},
		data() {
			return {
				identifyCodes: "1234567890",
				identifyCode: "",
				phone: '',
				imgCode: '',
				msgCode: '',
				content: '获取验证码',
				totalTime: 60,
				pageUrl: '',
				userid: '',
				usertoken: '',
				isCode: false,
				isMsgCode: false,
				isPhone: false,
				isCF: false
			};
		},
		created(){
			// 百度统计
			let _hmt = _hmt || [];
			(function() {
			  //每次执行前，先移除上次插入的代码
			  document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
			  let hm = document.createElement("script");
			  hm.src = "https://hm.baidu.com/hm.js?5bf14d717bf0afb01060aea203da42c2";
			  hm.id = "baidu_tj";
			  let s = document.getElementsByTagName("script")[0]; 
			  s.parentNode.insertBefore(hm, s);
			})();
		},
		mounted() {
			this.identifyCode = "";
			this.makeCode(this.identifyCodes, 4);
		},
		methods: {
			//随机验证码
			randomNum(min, max) {
				return Math.floor(Math.random() * (max - min) + min);
			},
			refreshCode() {
				this.identifyCode = "";
				this.makeCode(this.identifyCodes, 4);
			},
			makeCode(o, l) {
			  for (let i = 0; i < l; i++) {
				this.identifyCode += this.identifyCodes[
					this.randomNum(0, this.identifyCodes.length)
				];
			  }
			},
			//是否输入手机号
			hasPhone () {
				this.isPhone = true
			},
			//清除手机号
			clearPhone () {
				this.phone = ''
			},
			//输入图形验证码后按钮样式变化
			hasCode () {
				this.isCode = true
				this.isCF = false
			},
			//输入短信验证码后确定按钮样式
			hasMsgCode(){
				this.isMsgCode = true
			},
			//短信验证码倒计时
			countDown () {
				let that = this
				let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
				if(that.phone == ''){
					that.$toast({duration: 1000,message: '手机号不能为空'})
				}else if(!myreg.test(that.phone)){
					that.$toast({duration: 1000,message: '请输入正确的手机号'})
				}else{
					that.content = that.totalTime + 's后重发'; //这里解决60秒不见了的问题
					that.isCode = false
					that.isCF = true
					let clock = window.setInterval(() => {
						that.totalTime--
						that.content = that.totalTime + 's后重发'
						if (that.totalTime < 0) {     //当倒计时小于0时清除定时器
							window.clearInterval(clock)
							that.content = '重新发送'
							that.totalTime = 60
						}
					},1000);
					let formdata = new FormData();
					formdata.append('mobile', that.phone);
					that.$axios.post('http://sls.zhishen.net.cn/api/Yunpiansms/sendCode', formdata)
					.then(function (res) {
						if(res.data.code == 0){
							that.$toast({duration: 1000,message: res.data.msg});
							that.phone = '';
							that.imgCode = '';
							that.refreshCode();
							that.content = '获取验证码';
							window.clearInterval(clock);
							that.msgCode = '';	
						}else{
							that.$toast({duration: 1000,message: '发送成功'});
						}
						console.log(res.data)
					})
					.catch(function (error) {
						console.log(error);
					});
				}
			},
			//确定-绑定手机号
			bindPhone(){
				let that = this
				that.pageUrl = that.getUrlParam('buyUrl');
				if(that.imgCode == ''){
					that.$toast({duration: 1000,message: '请输入图形验证码'});
				}else if(that.imgCode != that.identifyCode){
					that.$toast({duration: 1000,message: '图形验证码不正确'});
					that.imgCode = '';
					that.refreshCode();
				}else if(that.msgCode == ''){
					that.$toast({duration: 1000,message: '请输入短信验证码'});
				}else{
					let formdata = new FormData();
					formdata.append('user_id', localStorage.getItem('userId'));
					formdata.append('mobile', that.phone);
					formdata.append('code', that.msgCode);
					that.$axios.post('http://sls.zhishen.net.cn/api/User/bindingMobile', formdata)
					.then(function (res) {
						window.location.href = that.pageUrl
					})
					.catch(function (error) {
						console.log(error);
					});
				}
			},
			getUrlParam(name){ 
				var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)"); 
				var r = window.location.search.substr(1).match(reg); 
				if (r!=null) return unescape(r[2]); return null; 
			}
		}
	}
</script>

<style>
	@import url("../../assets/css/personal.css");
	.code {
		margin: 400px auto;
		width: 114px;
		height: 40px;
		border: 1px solid red;
	}
</style>



// WEBPACK FOOTER //
// src/view/personal/bindphone.vue